<template>
  <div class="form-group">
    <dropzone
      :empty="!modelValue"
      class="mb-2 dropzone--with-action"
      @drop="drop"
    >
      <div class="file-list file-list--rows">
        <file-card
          v-if="modelValue"
          :file="modelValue"
          @remove="clearValue"
        />
      </div>

      <s-button v-if="!modelValue" @click="$refs.fileInput.click()" class="file-list-add-button btn-link px-0 font-weight-bold pt-0">
        <plus-circle-icon stroke-width="2"/>
        <span>{{ $t('actions.select_file') }}</span>
        <input
          ref="fileInput"
          type="file"
          @change="selectFile"
          class="opacity-0"
        >
      </s-button>
    </dropzone>
  </div>
</template>

<script>
  import Dropzone from '@/components/files/dropzone';
  import FileCard from '@/components/files/file-card';
  import PlusCircleIcon from '@/components/icons/plus-circle';

  export default {
    name: 'FileSelect',

    components: { FileCard, PlusCircleIcon, Dropzone },

    props: {
      // Value supports File or { name: '' }
      modelValue: {
        type: null,
        default: null,
      },
    },

    methods: {
      selectFile(e) {
        if (!e.target.files.length) {
          return;
        }

        this.$emit('update:modelValue', e.target.files[0]);
      },

      clearValue() {
        this.$emit('update:modelValue', null);
      },

      drop(file) {
        this.$emit('update:modelValue', file[0]);
      },
    },
  };
</script>
